export class SubaruModalBase {
    constructor(modalId, bodyClass) {
        this._modalTriggerButton = null;
        this._showModal = () => {
            document.body.classList.add(this._bodyClass);
            this._modal.removeAttribute("hidden");
            this._modal.classList.remove("fade");
            this._modal.classList.add("show");
            this._modal.focus();
            document.addEventListener("keydown", this._handleKeys);
        };
        this._hideModal = () => {
            if (this._modalTriggerButton) {
                this._modalTriggerButton.focus();
            }
            document.body.classList.remove(this._bodyClass);
            this._modal.setAttribute("hidden", "true");
            this._modal.classList.remove("show");
            this._modal.classList.add("fade");
            document.removeEventListener("keydown", this._handleKeys);
        };
        this._handleKeys = (e) => {
            if (e.key === "Escape" /* Key.Escape */) {
                this._hideModal();
                return;
            }
            else if (e.key !== "Tab" /* Key.Tab */) {
                return;
            }
            this.trapFocus(e);
        };
        this._modal = document.getElementById(modalId);
        this._bodyClass = bodyClass;
        if (!this._modal) {
            console.warn(`${this.constructor.name} was loaded, but the modal with id ${modalId} was not found.`);
            return;
        }
        this.addBaseEventListeners();
    }
    addBaseEventListeners() {
        const closeButtons = this._modal.querySelectorAll("[data-dismiss='modal']");
        closeButtons.forEach((btn) => btn.addEventListener("click", this._hideModal));
        this._modal.addEventListener("mousedown", (e) => {
            if (e.target === this._modal) {
                this._hideModal();
            }
        });
    }
}
